import { combineReducers } from 'redux'
import common from './common'
import config from './config'
import field from './field'

export default combineReducers({
    common,
    field,
    config
})
